import { ReactElement } from 'react';
import { AiOutlineCar } from 'react-icons/ai';
import { BsPeople } from 'react-icons/bs';
import { FaRegListAlt } from 'react-icons/fa';
import { LuLayoutDashboard } from 'react-icons/lu';
import { PiMoney } from 'react-icons/pi';
import { TbFileExport } from 'react-icons/tb';

interface ISubmenu {
  path: string;
  title: string;
}
export interface ISidebar {
  id: number;
  icon: ReactElement;
  title: string;
  path: string;
  submenu?: ISubmenu[];
}

const data = [
  {
    id: 0,
    icon: <LuLayoutDashboard />,
    title: 'Dashboard',
    path: 'dashboard',
  },
  {
    id: 1,
    icon: <AiOutlineCar />,
    title: 'Veículos',
    path: 'vehicles',
  },
  {
    id: 2,
    icon: <BsPeople />,
    title: 'Condutores',
    path: 'drivers',
  },
  {
    id: 3,
    icon: <PiMoney />,
    title: 'Débitos',
    path: 'debts',
  },
  {
    id: 4,
    icon: <FaRegListAlt />,
    title: 'Pedidos',
    path: 'orders',
  },
  {
    id: 6,
    icon: <TbFileExport />,
    title: 'Exportações',
    path: 'exports',
  },
];

export const usersSideBar = {
  id: 5,
  icon: <BsPeople />,
  title: 'Usuários',
  path: 'users',
};

export default data;
